<div class="min-h-screen bg-slate-100 flex items-center justify-center p-8">

  <div class="w-full max-w-4xl bg-white border border-slate-300 rounded-xl shadow-sm">

    <!-- ================= HEADER ================= -->
    <div class="px-10 py-6 border-b border-slate-200">
      <h1 class="text-lg font-semibold text-slate-900 tracking-tight">
        Payment Configuration
      </h1>
      <p class="mt-1 text-sm text-slate-500">
        Complete the steps below to validate your transaction.
      </p>
    </div>

    <!-- ================= PROGRESS BAR ================= -->
    <div class="px-10 pt-6">

      <div class="relative h-1 bg-slate-200 rounded-full overflow-hidden">
        <div
          class="absolute left-0 top-0 h-full bg-slate-900 transition-all duration-300 ease-out"
          [style.width.%]="progressPercent()">
        </div>
      </div>

      <div class="mt-2 text-xs text-slate-500 text-right">
        Step {{ currentStep() + 1 }} of {{ steps.length }}
      </div>

    </div>

    <!-- ================= STEPS ================= -->
    <div class="px-10 pt-8">

  <div class="relative flex justify-between items-start">

    <!-- Ligne horizontale -->
    <div class="absolute top-4 left-0 right-0 h-px bg-slate-200"></div>

    <div *ngFor="let step of steps; let i = index"
         class="relative flex flex-col items-center flex-1">

      <!-- Cercle -->
      <div
        class="w-9 h-9 rounded-full flex items-center justify-center text-xs font-semibold
               transition-all duration-200 relative z-10"
        [ngClass]="getStepClasses(i)">

        <!-- Step complété -->
        <ng-container *ngIf="i < currentStep()">
          <svg @checkFade
               class="w-4 h-4 text-emerald-600"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               viewBox="0 0 24 24">
            <path stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M5 13l4 4L19 7"/>
          </svg>
        </ng-container>

        <!-- Step actif / futur -->
        <ng-container *ngIf="i >= currentStep()">
          {{ i + 1 }}
        </ng-container>

      </div>

      <!-- Label -->
      <span class="mt-3 text-xs font-medium text-slate-600 text-center">
        {{ step.title }}
      </span>

    </div>

  </div>

</div>

    <!-- ================= CONTENT ================= -->
    <div class="px-10 py-10 min-h-[240px] transition-all duration-200">

      <ng-container [ngSwitch]="currentStep()">

        <!-- STEP 1 -->
        <div *ngSwitchCase="0">
          <h2 class="text-base font-semibold text-slate-900 mb-6">
            Beneficiary Information
          </h2>

          <div class="space-y-5">

            <div>
              <label class="block text-sm text-slate-600 mb-1">
                Beneficiary Name
              </label>
              <input
                type="text"
                class="w-full border border-slate-300 rounded-md px-4 py-2 text-sm
                       focus:outline-none focus:ring-0 focus:border-red-600 transition"
                placeholder="John Doe Ltd" />
            </div>

            <div>
              <label class="block text-sm text-slate-600 mb-1">
                IBAN
              </label>
              <input
                type="text"
                class="w-full border border-slate-300 rounded-md px-4 py-2 text-sm
                       focus:outline-none focus:ring-0 focus:border-red-600 transition"
                placeholder="FR76 XXXX XXXX XXXX XXXX XXXX XXX" />
            </div>

          </div>
        </div>

        <!-- STEP 2 -->
        <div *ngSwitchCase="1">
          <h2 class="text-base font-semibold text-slate-900 mb-6">
            Transaction Details
          </h2>

          <div class="space-y-5">

            <div>
              <label class="block text-sm text-slate-600 mb-1">
                Amount
              </label>
              <input
                type="number"
                class="w-full border border-slate-300 rounded-md px-4 py-2 text-sm
                       focus:outline-none focus:ring-0 focus:border-red-600 transition"
                placeholder="0.00" />
            </div>

            <div>
              <label class="block text-sm text-slate-600 mb-1">
                Reference
              </label>
              <input
                type="text"
                class="w-full border border-slate-300 rounded-md px-4 py-2 text-sm
                       focus:outline-none focus:ring-0 focus:border-red-600 transition"
                placeholder="Invoice 2025-001" />
            </div>

          </div>
        </div>

        <!-- STEP 3 -->
        <div *ngSwitchCase="2">
          <h2 class="text-base font-semibold text-slate-900 mb-6">
            Review & Confirmation
          </h2>

          <div class="bg-slate-50 border border-slate-200 rounded-md p-6 text-sm text-slate-700 space-y-2">
            <p>Please verify the transaction details before submission.</p>
            <p class="text-slate-500">
              Once confirmed, this instant payment cannot be cancelled.
            </p>
          </div>
        </div>

      </ng-container>

    </div>

    <!-- ================= FOOTER ================= -->
    <div class="px-10 py-6 border-t border-slate-200 flex justify-between">

      <button
        (click)="previous()"
        [disabled]="currentStep() === 0"
        class="px-5 py-2 text-sm border border-slate-300 rounded-md text-slate-700
               hover:bg-slate-100 disabled:opacity-40 transition">
        Back
      </button>

      <button
        (click)="next()"
        [disabled]="currentStep() === steps.length - 1"
        class="px-5 py-2 text-sm rounded-md bg-slate-900 text-white
               hover:bg-slate-800 transition">
        Continue
      </button>

    </div>

  </div>
</div>